<div id="scrollId"></div>
<div class="view-auth-container">
    @if (!editAuthorizations()) {
    <a (click)="navigateToUserAdmin()" class="back-to-users-link"><< Back to Users List</a>
    }
    <h4 class="view-or-edit-auth-heading">{{!editAuthorizations() ? 'Viewing ':'Managing '}}Authorizations</h4>
    <div class="userId">
        <div>
            <span>Selected User:</span> <strong>{{ userInfo().selectedUserId }}</strong>
            <span style="padding-left: 15px;">User type:</span> <strong>{{ userInfo().selectedUserType }}</strong>
        </div>
        @if (!multipleClients()) {
            <div class="user-context">
                <span>Payer:</span><strong>{{userContext()[1]}}</strong>
                <span>Group:</span><strong>{{userContext()[2]}}</strong>
            </div>
        }
        @if (!editAuthorizations()) {
        <button rs-raised-button color="primary" (click)="editAuthorizations.set(true)">Edit</button>
        }
    </div>
    @if (!editAuthorizations()) {
        @if (fetchingClients()) {
        <rs-loader></rs-loader>
        }
        @if (!multipleClients()) {
            <bmt-view-auth-at-group [userInfo]="userInfo()" [userContext]="userInfo().contextOfAdmin" [selectedUserId]="userInfo().selectedUserId"></bmt-view-auth-at-group>
        }
        @if (multipleClients()) {
            <div class="admin-clients-container">
                @if (errorsFetchingClients()) {
                <p class="error">Errors fetching clients: {{errorsFetchingClients()}}</p>
                }
                @for (clientsInfo of adminClientsInfo(); track clientsInfo.specifiedId + 'index' + $index; let i = $index) {
                    @if (clientsInfo.specifiedId) {
                        <div class="admin-clients">
                            <button type="button" class="user-context" (click)="toggleTheClient(clientsInfo.specifiedId+'index'+i)">
                                <span class="arrows">
                                    @if (selectedClient() !== clientsInfo.specifiedId+'index'+i) {
                                    <span>&#43;</span>
                                    }
                                    @if (selectedClient() === clientsInfo.specifiedId+'index'+i) {
                                    <span>&#8722;</span>
                                    }
                                </span>
                                <span class="context">
                                    <span>Payer: </span>{{clientsInfo.planAcronym}}
                                    <span>Group Name: </span>{{clientsInfo.name}}
                                    <span>Group Id: </span>{{clientsInfo.specifiedId}}
                                </span>
                            </button>
                            @if (selectedClient() === clientsInfo.specifiedId+'index'+i) {
                                <bmt-view-auth-at-group [userInfo]="userInfo()" [userContext]="userContext()[0]+'/'+clientsInfo.planAcronym+'/'+clientsInfo.specifiedId" [selectedUserId]="userInfo().selectedUserId"></bmt-view-auth-at-group>
                            }
                        </div>
                    }
                }
            </div>
            <div class="pagination-container">
                <rs-paginator [length]="totalRecords()"
                        (page)="getMoreClients($event)" [showFirstLastButtons]="1"
                        [pageSize]="defaultPageSize"></rs-paginator>
            </div>
        }
    }
    @if (editAuthorizations()) {
    <bmt-manage-auth [userInfo]="userInfo()" (cancelEdit)="editAuthorizations.set(false)"></bmt-manage-auth>
    }
</div>
